var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "self-procurement-register" },
    [
      _c("Filtersearch", {
        ref: "Filtersearchref",
        attrs: { fromdata: _vm.formData, list: _vm.Filtersearchlist },
        on: { Refresh: _vm.onHandleRefresh, search: _vm.onSearch },
        scopedSlots: _vm._u([
          {
            key: "right",
            fn: function () {
              return [
                _c(
                  "el-button",
                  {
                    attrs: {
                      type: "warning",
                      icon: "el-icon-download",
                      disabled: !_vm.tableData.length || _vm.disabledExport,
                    },
                    on: { click: _vm.exportHandle },
                  },
                  [_vm._v("导出")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "div",
        { staticClass: "table-wrap" },
        [
          _c("table-list", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: { tableData: _vm.tableData, is_audit: _vm.is_audit },
            on: {
              openEditGoods: _vm.openEditGoods,
              onHandleShow: _vm.onHandleShow,
              onsubmitRefresh: _vm.onsubmitRefresh,
              onHandleViewLog: _vm.onHandleViewLog,
              openCancelRemark: _vm.openCancelRemark,
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "fy" },
        [
          _c("el-pagination", {
            attrs: {
              type: "primary",
              background: "",
              "current-page": _vm.formData.page,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.formData.pageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.onHandleSizeChange,
              "current-change": _vm.onHandleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: " ",
            visible: _vm.tipShow,
            width: "30%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.tipShow = $event
            },
          },
        },
        [
          _c("span", [_vm._v(" 您是否确认作废此条记录？ ")]),
          _c(
            "div",
            [
              _c("div", { staticClass: "mt-10 mb-10" }, [_vm._v("备注:")]),
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  autosize: { minRows: 2, maxRows: 4 },
                  placeholder: "请输入备注",
                  maxlength: "200",
                },
                model: {
                  value: _vm.remark,
                  callback: function ($$v) {
                    _vm.remark = $$v
                  },
                  expression: "remark",
                },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.sureHandle } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("edit-goods", {
        ref: "editGoodsRef",
        attrs: { typeList: _vm.typeList },
        on: { onsubmitRefresh: _vm.onsubmitRefresh },
      }),
      _c("c-preview-file", {
        attrs: {
          fileList: _vm.fileList,
          fileIndex: _vm.previewIndex,
          fileType: _vm.fileType,
        },
        model: {
          value: _vm.dialogVisible,
          callback: function ($$v) {
            _vm.dialogVisible = $$v
          },
          expression: "dialogVisible",
        },
      }),
      _c("operationRecord", { ref: "operationRecordRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }